import { 
  cacheExchange,
  fetchExchange,
  createClient,
  mapExchange,
} from '@urql/core'

import { authExchange } from '@urql/exchange-auth'
import { GraphQLError } from "graphql"
import { firebaseTools } from './firebase'
import { state } from './localStorage'
import { clientPlatform } from './clientPlatform'
import { useAuthStore } from '@/stores'
import { reportGraphQLStall } from './backendStallReporting'

import * as Sentry from "@sentry/vue"

const UNAUTHENTICATED_CODE = "validation-failed"

const getToken = async () => {
  if (!!state.value.jwtRefresh && new Date(state.value.jwtRefresh).getTime() > Date.now()) {
    return { token: state.value.jwt }
  } else {
    const {token:newToken, jwtRefresh} = await firebaseTools.getCurrentUserJWT(true) || ''
    state.value.jwt = newToken
    state.value.jwtRefresh = jwtRefresh
    if (newToken !== '') {
      return { token: newToken }
    } else {
      state.value.jwt = ''
      state.value.jwtRefresh = ''
      return { token: null }
    }
  }
}

const willAuthError = () => {
  // e.g. check for expiration, existence of auth etc\
  if (!state.value.jwt || state.value.jwt === '') return true;
  const timeLeft = new Date(state.value.jwtRefresh).getTime() - new Date().getTime()
  if (timeLeft > 0) return false;
  return true;
}

const didAuthError = (error: any) => {
	return error.graphQLErrors.some(
		(e: GraphQLError) => e.extensions?.code === UNAUTHENTICATED_CODE 
	)
}
export const urqlConfig: any = {
  url: 'https://rutasegura-api.isaga.workers.dev',
  fetchOptions: {
    headers: {
      'content-type': 'application/json',
      // Lets the gateway logs tell app users from admins on PC (both send an Origin).
      'graphql-client-name': clientPlatform,
    },
  },
  requestPolicy: 'cache-and-network',
  exchanges: [
    mapExchange({
      onError(error, operation) {
        // Statement timeouts and gateway 5xx feed the stall detector (backendStall.ts), which slows every retry and
        // poll loop down while the database is saturated.
        reportGraphQLStall(error)
        console.info(operation.query, operation.variables)
        console.info(error)
      },
    }),
    cacheExchange,
    authExchange(async utils => {
      return {
        addAuthToOperation(operation) {
          if (!state.value.jwt || state.value.jwt === '') return operation;
          const {account} = useAuthStore()
          return utils.appendHeaders(operation, {
            Authorization: `Bearer ${state.value.jwt}`,
            'user-id': account?.id || '',
          })
        },
        didAuthError,
        willAuthError,
        refreshAuth: async () => {
          try {
            await getToken()
          } catch (error) {
            // TODO: send to logout page
            Sentry.captureException(error)
          }
        },
      };
    }),
    fetchExchange,
  ],
}

export const client = createClient(urqlConfig)